import React from 'react';
import { AvatarCard, BackButton, OutlinedIcons } from '@marageti/z4-lib';
import { TripRequest } from '@marageti/z4-sdk/lib/travel';
import SubNavigation from '../sub-navigation';

type TripRequestSecondaryAppbarViewProps = {
  tripRequest?: TripRequest | undefined;
};

const TripRequestSecondaryAppbarView = ({
  tripRequest,
}: TripRequestSecondaryAppbarViewProps) => (
  <SubNavigation
    profile={{
      avatar: (
        <AvatarCard
          alt="Zicasso Care Specialist"
          size={32}
          sx={{ backgroundColor: 'common.gold', color: 'background.default' }}
        >
          Z
        </AvatarCard>
      ),
      primary: 'Zicasso Care Specialist',
    }}
    startAdornment={(
      <BackButton
        data-e2e="ztest-trip-match-back"
        defaultPath={`/trip-requests/${tripRequest?.id}`}
        options={{
          replace: true,
        }}
        edge="start"
      >
        <OutlinedIcons.OutlinedArrowSmLeftIcon color="primary" />
      </BackButton>
      )}
  />
);

export default TripRequestSecondaryAppbarView;
